import React from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="dashboard__main">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 200px)" }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          style={{ maxWidth: "560px", width: "100%" }}
        >
          {/* Large 404 Number */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            style={{ textAlign: "center", marginBottom: "32px" }}
          >
            <h1
              style={{
                fontSize: "120px",
                fontWeight: 800,
                lineHeight: 1,
                margin: 0,
                color: "var(--nba-green)",
                letterSpacing: "-0.04em",
              }}
            >
              404
            </h1>
          </motion.div>

          {/* Main Content Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "16px",
              padding: "40px 32px",
              boxShadow: "var(--card-shadow)",
            }}
          >
            <h2
              className="dashboard-page__title"
              style={{
                fontSize: "22px",
                textAlign: "center",
                marginBottom: "12px",
              }}
            >
              Page Not Found
            </h2>

            <p
              style={{
                fontSize: "14px",
                color: "#6b7280",
                textAlign: "center",
                marginBottom: "32px",
                lineHeight: 1.6,
                marginTop: "8px",
                marginLeft: 0,
                marginRight: 0,
              }}
            >
              The page you're looking for doesn't exist or has been moved. Check the URL or navigate back to the dashboard.
            </p>

            {/* Action Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.99 }}>
                <Link
                  to="/d"
                  className="dashboard-button"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    textDecoration: "none",
                    height: "36px",
                    fontSize: "13px",
                  }}
                >
                  <LayoutDashboard size={16} aria-hidden="true" />
                  Go to Dashboard
                </Link>
              </motion.div>

              <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.99 }}>
                <button
                  onClick={() => navigate(-1)}
                  className="dashboard-page__back-button"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    height: "36px",
                    fontSize: "13px",
                    display: "inline-flex",
                  }}
                >
                  <ArrowLeft size={16} aria-hidden="true" />
                  Go Back
                </button>
              </motion.div>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
